import React from 'react';
import Header from '../../../Reusable/Header';
import Footer from '../../../Reusable/Footer';
import CampaignDetails from './Page components/Campaigns/CampaignDetails';



const Contact = () => {

  return (
    <div>
      <Header />
      <CampaignDetails />

  
      <Footer />
    </div>
  );
};

export default Contact;